import './styles.css';

export const Speakers = ({ speakers = [] }) => {
  return (
    <div className="speakers">
      <div className="container">
        <div className="row">
          {speakers.map((s) => (
            <div key={s.name} className="col-md-3 text-center">
              <div className="col-md-12">
                <img
                  className="img"
                  src={s.picture ? s.picture : 'img/event/2.jpg'}
                  alt=""
                />
              </div>
              <h4>{s.name}</h4>
              <p>{s.from}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
